export const to = (promise) =>
  promise.then((data) => [null, data]).catch((err) => [err]);

export const setPositionFixed = (node) => {
  node.style.position = 'fixed';
};
